import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Button, UncontrolledTooltip } from 'reactstrap';
import { FieldArray } from 'formik';
import { isEmpty } from 'lodash';
import { TbX } from 'react-icons/tb';
import { FormInputField } from '../../../common/components/formFields';
import PendingActionButtons from '../PendingActionButtons';
import { DealerPendingActionTypes } from '../../../constants/DealerPendingActionTypes';
import PostcodeSelectField from './postcode/PostcodeSelectField';

function DealerLocationForm({ locations, disabled, preparePendingActionObj }) {
  const mainLocationDataObj = preparePendingActionObj(
    DealerPendingActionTypes.MAIN_LOCATION_CHANGE,
  );

  const additionalLocationDataObj = preparePendingActionObj(
    DealerPendingActionTypes.ADD_ADDITIONAL_LOCATION,
  );

  return (
    <>
      <h4 className="my-3 fw-bold">Company location</h4>
      <Row>
        <Col md="4">
          <FormInputField
            name="mainLocation.name"
            label="Location Name"
            disabled={disabled}
            required
          />
        </Col>
        <Col md="4">
          <FormInputField name="address" label="Address" disabled={disabled} required />
        </Col>
        <Col md="4">
          <FormInputField name="address2" label="Address - Line 2" disabled={disabled} />
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <FormInputField name="city" label="Town" disabled={disabled} required />
        </Col>
        <Col md="4">
          <PostcodeSelectField
            name="mainLocation.postalCode"
            label="Post Code"
            loadRightAway={false}
            required
          />
        </Col>
        <Col md="4">
          <FormInputField name="county" label="County" disabled={disabled} required />
        </Col>
      </Row>
      {mainLocationDataObj?.id && (
        <PendingActionButtons
          data={mainLocationDataObj}
          type={DealerPendingActionTypes.MAIN_LOCATION_CHANGE}
        />
      )}
      <h4 className="my-3 fw-bold">Additional location</h4>
      <FieldArray
        name="locations"
        render={(arrayHelpers) => (
          <div>
            {locations.map((location, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Row key={index} className="position-relative mb-3">
                <Col md="12">
                  {location.canBeDeleted === false ? (
                    <>
                      <span id={`location-delete-${location.id}`} className="float-end">
                        <Button type="button" className="rounded-pill btn-danger" disabled>
                          <TbX />
                        </Button>
                      </span>
                      <UncontrolledTooltip
                        className="uncontrolled-tooltip"
                        delay={0}
                        target={`location-delete-${location.id}`}
                      >
                        This location cannot be deleted because it is associated with
                        transactions, bids or auctions.
                      </UncontrolledTooltip>
                    </>
                  ) : (
                    <Button
                      type="button"
                      className="float-end rounded-pill btn-danger"
                      onClick={() => arrayHelpers.remove(index)}
                    >
                      <TbX />
                    </Button>
                  )}
                </Col>
                <Col md="4">
                  <FormInputField
                    name={`locations.${index}.name`}
                    label="Location Name"
                    required
                  />
                </Col>
                <Col md="4">
                  <FormInputField
                    name={`locations.${index}.address`}
                    label="Address"
                    required
                  />
                </Col>
                <Col md="4">
                  <FormInputField
                    name={`locations.${index}.address2`}
                    label="Address - Line 2"
                  />
                </Col>
                <Col md="4">
                  <FormInputField name={`locations.${index}.city`} label="Town" required />
                </Col>
                <Col md="4">
                  <PostcodeSelectField
                    name={`locations.${index}.postalCode`}
                    label="Post Code"
                    required
                  />
                </Col>
                <Col md="4">
                  <FormInputField name={`locations.${index}.county`} label="County" required />
                </Col>
                {!isEmpty(additionalLocationDataObj) && (
                  <Col xs="12">
                    <PendingActionButtons
                      data={additionalLocationDataObj}
                      type={DealerPendingActionTypes.ADD_ADDITIONAL_LOCATION}
                      locationId={location.id}
                    />
                  </Col>
                )}
              </Row>
            ))}
            <Button
              className="rounded-pill btn-light"
              type="button"
              onClick={() =>
                arrayHelpers.push({
                  postalCode: { id: '', postcode: '', value: '' },
                  name: '',
                  address: '',
                  city: '',
                  county: '',
                })
              }
            >
              Add Additional Location
            </Button>
          </div>
        )}
      />
    </>
  );
}

DealerLocationForm.defaultProps = {
  disabled: false,
  locations: [],
};

DealerLocationForm.propTypes = {
  disabled: PropTypes.bool,
  preparePendingActionObj: PropTypes.func.isRequired,
  locations: PropTypes.array,
};

export default DealerLocationForm;
